/**
 * Replace native logger for Jest.
 *
 * @param {...any} args
 * @return {void}
 */
const log = (...args) => {
    return;
    if (process.env.NODE_ENV === 'test') return;

    console.log(...args);
};

/** @type {import("@/types").AdManager} */
const AdManager = {
    lastShown: null, // unix time of the last popup event, used to limit frequency
    showCounter: 0, // total popup event counter
    freeRouteViews: 2, // each watched route can be viewed n times without popup
    routeViewCap: {}, // total module views, to enable free demo views (by module mounted events) n times
    frequencyBase: 120, // default frequency limit (delay between 2 popups), in seconds
    frequencyCap: 60, // minimum frequency limit, in seconds
    frequencyMultiplier: 0.6, // actualFrequency = frequencyBase - round ( showCounter * frequencyMultiplier), limited by frequencyCap
    countdownBase: 7, // seconds before popup can be closed
    countdownCap: 30, // maximum countdown value
    countdownMultiplier: 0.2, // actualCountdown = round ( showCounter * countdownMultiplier) + countdownBase, limited by countdownCap
    storageKey: 'qm3k6tJWzY', // @todo - save/retrieve a copy of logged data with Flutter
    inited: false,

    init() {
        this.loadData();
        this.inited = true;
        // @TODO: store first start if not stored yet - do this in flutter!
    },

    /**
     * Show popup after validations
     * @param route
     * @return {boolean}
     */
    show(route) {

        return false;

        // if (location.hostname === "localhost" || location.hostname.includes("192.168.0.")) return false;

        const hostname = String(location.hostname);

        if (hostname === "localhost" || hostname.includes("192.168.0.")) return false;

        if (!this.inited) this.init();

        // Prevent on paid users
        if (window.packageName !== "com.denticalc.4in1") return false;
        if (window.IAP.hasPremiumAccess()) return false;

        // Check if popup should be shown
        // @TODO: remove route cap, add x free days
        if (!this.isRouteViewCapReached(route) || this.isFrequencyCapped()) return false;

        const countdown = this.getCountdown();
        log('countdown', countdown);
        this.logAdView();
        window.app.$bus.$emit("free_trial:show", {
            countdown: countdown,
            route: route,
        });

        const trialEndCount = parseInt(localStorage.getItem('trialEndCount') || '0', 10) + 1;

        localStorage.setItem('trialEndCount', String(trialEndCount));

        window.Tracker.logEvent({
            event_label: 'trialEndCount',
            event_name: 'trial_end_count',
            event_value: trialEndCount,
        });

        return true;
    },

    /**
     * Get actual countdown timer start
     * @return {number}
     */
    getCountdown() {
        const countdown = Math.round((this.showCounter || 0) * this.countdownMultiplier) + this.countdownBase;
        return (countdown < this.countdownCap) ? countdown : this.countdownCap;
    },

    /**
     * Check if previous ad display was too recently
     * @return {boolean}
     */
    isFrequencyCapped() {
        if (!this.lastShown) return false;
        const now = Math.floor(Date.now() / 1000);
        log('Frequency', now - this.lastShown);
        return (now - this.lastShown < this.getFrequency());
    },

    /**
     * Get actual frequency limit
     * @return {number}
     */
    getFrequency() {
        const freq = this.frequencyBase - Math.round((this.showCounter || 0) * this.frequencyMultiplier);
        return (freq < this.frequencyCap) ? this.frequencyCap : freq;
    },

    /**
     * Check if user is within the free route views
     * @param {string} route
     * @return {boolean}
     */
    isRouteViewCapReached(route) {
        log(this.routeViewCap);
        if (typeof this.routeViewCap[route] === 'undefined') this.routeViewCap[route] = 0;
        return this.routeViewCap[route] > (this.freeRouteViews || 2);
    },

    /**
     * Increment route view counter
     * @param {string} route
     * @return {void}
     */
    logRouteView(route) {
        log('Log route view ' + route);
        try {
            if (!this.inited) this.init();
            if (typeof this.routeViewCap[route] === 'undefined') this.routeViewCap[route] = 0;
            this.routeViewCap[route]++;
            this.storeData();
        } catch(error) {
            captureException(error);
        }
    },

    /**
     * Increment global view counter
     * @return {void}
     */
    logAdView() {
        this.showCounter && this.showCounter++;
        this.lastShown = Math.floor(Date.now() / 1000);
        this.storeData();
    },

    /**
     * Load usage data from localStorage
     * @return {void}
     */
    loadData() {
        try {
            if (!window.localStorage.getItem(this.storageKey)) return;

            // const data = JSON.parse(atob(window.localStorage.getItem(this.storageKey)));
            const data = JSON.parse(localStorage.getItem(this.storageKey) || '{}');

            ['lastShown', 'showCounter', 'routeViewCap'].forEach(key => {
                this[key] = data[key];
            });
        } catch(error) {
            captureException(error);
        }
    },

    /**
     * Store usage data in base64 encoded JSON string
     * @return {void}
     */
    storeData() {
        try {
            const data = {};

            ['lastShown', 'showCounter', 'routeViewCap'].forEach(key => {
                data[key] = this[key];
            });

            // window.localStorage.setItem(this.storageKey, btoa(JSON.stringify(data)));
            window.localStorage.setItem(this.storageKey, JSON.stringify(data));
        } catch(error) {
            captureException(error);
        }
    },
};

export default AdManager;
